import { EventBuilder } from 'faster-sdk-js'

export default class FasterEvent {
  constructor(eventData, addDimensions) {
    this.id = eventData.id
    this.revision = eventData.revision
    this._addDimensions = addDimensions
  }

  build(parameters) {
    const eventBuilder = new EventBuilder(this.id, this.revision)
    return this._addDimensions(eventBuilder, parameters)
  }
}
